import Axios from "axios";
export class Subscriptions {
    // Set subscriptions url
    constructor(apiUrl, headers) {

        this.subscribersUrl = `${apiUrl}/subscriptions`;
        this.headers = headers;
    }


    async getRecurringNotifyReport() {
        const url = `${this.subscribersUrl}/report/recurring-notify`;
        const _headers = {
            ...this.headers,
            Accept: "application/octet-stream",
        };

        const response = await Axios.get(
            url, { headers: _headers,  responseType: 'blob' }
          );

        return response
    }
}


// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/subscriptions.js